import React from 'react';
import CreateAuditFormView from '../components/CreateAuditFormView';
import CreateAuditSetupView from '../components/CreateAuditSetupView';
import useCreateAuditPageLogic from '../hooks/useCreateAuditPageLogic';

const CreateAuditPage: React.FC = () => {
  const {
    loading,
    error,
    stores,
    selectedStore,
    selectedStoreData,
    shiftDate,
    shiftStartTime,
    shiftEndTime,
    showForm,
    fetchingPrevious,
    saving,
    previousAuditCount,
    formData,
    gamesMapState,
    hoveredRowIndex,
    handleStoreChange,
    handleShiftDateChange,
    handleShiftStartTimeChange,
    handleShiftEndTimeChange,
    handleContinue,
    handleSubmit,
    handleFormDataUpdate,
    handleBackToSetup,
    handleBackToAuditList,
    handleRowHover,
  } = useCreateAuditPageLogic();

  if (showForm && formData) {
    return (
      <CreateAuditFormView
        storeName={selectedStoreData?.name || ''}
        shiftDate={shiftDate}
        shiftStartTime={shiftStartTime}
        shiftEndTime={shiftEndTime}
        previousAuditCount={previousAuditCount}
        formData={formData}
        gamesMapState={gamesMapState}
        saving={saving}
        hoveredRowIndex={hoveredRowIndex}
        onBack={handleBackToSetup}
        onBackToAuditList={handleBackToAuditList}
        onSubmit={handleSubmit}
        onFormDataUpdate={handleFormDataUpdate}
        onRowHover={handleRowHover}
      />
    );
  }

  return (
    <CreateAuditSetupView
      loading={loading}
      error={error}
      stores={stores}
      selectedStore={selectedStore}
      shiftDate={shiftDate}
      shiftStartTime={shiftStartTime}
      shiftEndTime={shiftEndTime}
      fetchingPrevious={fetchingPrevious}
      onStoreChange={handleStoreChange}
      onShiftDateChange={handleShiftDateChange}
      onShiftStartTimeChange={handleShiftStartTimeChange}
      onShiftEndTimeChange={handleShiftEndTimeChange}
      onContinue={handleContinue}
      onBackToAuditList={handleBackToAuditList}
    />
  );
};

export default CreateAuditPage;
